import { render, staticRenderFns } from "./SaveEditCancelButtons.vue?vue&type=template&id=2da8c498&"
import script from "./SaveEditCancelButtons.vue?vue&type=script&lang=js&"
export * from "./SaveEditCancelButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports